const SubCategory = {
    
    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",
    "category": "الفئة",

    // PAGE HEADER
    "sub_category": "الفئة الفرعية",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء اختيار الحالة",
    "error_category": "الرجاء اختيار الفئة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_category": "الفئة",
    "table_status": "الحالة",

};

export default SubCategory;